import { useEffect } from 'react';
var ABTESTING_EVENT_REQUIRED_FIELDS = [
    'clientID',
    'octopus_testName',
    'octopus_variantName',
    'octopus_feedbackID',
    'octopus_mode',
    'octopus_variantResponse',
];
export var useAutologinTracking = function (getCookie, track) {
    useEffect(function () {
        var trackEventEncoded = getCookie('zl_autologin_tracking');
        if (!trackEventEncoded) {
            return;
        }
        try {
            var trackEvent_1 = JSON.parse(atob(trackEventEncoded));
            var isTrackEventValid = ABTESTING_EVENT_REQUIRED_FIELDS.every(function (key) { return typeof trackEvent_1[key] !== 'undefined'; });
            if (!isTrackEventValid) {
                return;
            }
            track('TRACK_ABTESTING', trackEvent_1);
        }
        catch (err) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.error('[@browsing/hooks] Failed to track auto-login test.', err);
            }
        }
    }, []);
};
